<h1 fxLayoutAlign="center">Frequently Asked Questiones</h1>

<div fxLayout="column" fxLayoutAlign="space-around">
	<mat-accordion>
		<mat-expansion-panel>
			<mat-expansion-panel-header>
				Q1. When is next course starting ?
			</mat-expansion-panel-header>

			<ng-template matExpansionPanelContent>
				Nov 2020
			</ng-template>
		</mat-expansion-panel>

		<mat-expansion-panel>
			<mat-expansion-panel-header>
				Q2. Is there any coaching classes conducted by TOP CREW for Entrance Examination ?
			</mat-expansion-panel-header>

			<ng-template matExpansionPanelContent>
				No, there are no Coaching Classes conducted for Entrance Examination by TOP CREW.
			</ng-template>
		</mat-expansion-panel>

		<mat-expansion-panel>
			<mat-expansion-panel-header>
				Q3. What are the qualifications required for applying for Ab-initio to CPL ?
			</mat-expansion-panel-header>

			<ng-template matExpansionPanelContent>
				The educational qualification is 10+2 or equivalent with 55% marks for all Categories.
			</ng-template>
		</mat-expansion-panel>

		<mat-expansion-panel>
			<mat-expansion-panel-header>
				Q4. Which all are the centers where written examination is conducted ?
			</mat-expansion-panel-header>

			<ng-template matExpansionPanelContent>
				Examination is conducted at major cities all over India. Candidates are asked to give two choices for Centres. Some Examination
				Centres may be cancelled if the choice for the centre from candidates is not adequate.
			</ng-template>
		</mat-expansion-panel>

		<mat-expansion-panel>
			<mat-expansion-panel-header>
				Q5. Any loan facility provided by the Top Crew ?

			</mat-expansion-panel-header>

			<ng-template matExpansionPanelContent>
				We dont have tie up with any bank for providing loan to trainees for doing CPL course at TOP CREW. We provide help to candidates
				in getting loan by way of certificates regarding selection/Bonafide trainee and training fee and other expenses details.
				The candidates have to approach banks themselves and complete loan formalities.
			</ng-template>
		</mat-expansion-panel>

		<mat-expansion-panel>
			<mat-expansion-panel-header>
				Q6. Any financial assistance provided to SC/ST/OBC Candidates ?
			</mat-expansion-panel-header>

			<ng-template matExpansionPanelContent>
				The training fee and other expenditure is same for all category candidates.
			</ng-template>
		</mat-expansion-panel>

		<mat-expansion-panel>
			<mat-expansion-panel-header>
				Q7. What is the minimum and Maximum age limit for joining the course ?
			</mat-expansion-panel-header>

			<ng-template matExpansionPanelContent>
				Although candidates with less than 16 years may be permitted to undergo selection process but they must not be less than
				17 before joining the course.
			</ng-template>
		</mat-expansion-panel>

		<mat-expansion-panel>
			<mat-expansion-panel-header>
				Q8. What is the maximum age limit for issue of CPL ?
			</mat-expansion-panel-header>

			<ng-template matExpansionPanelContent>
				60 years is age limit for issue of CPL .
			</ng-template>
		</mat-expansion-panel>

		<mat-expansion-panel>
			<mat-expansion-panel-header>
				Q9. What is the Fee Structure ?
			</mat-expansion-panel-header>

			<ng-template matExpansionPanelContent>
				Fee Structure would be approx 34 Lakhs(payable in four quarterly installments in one year) for those who qualify our selection
				process.
			</ng-template>
		</mat-expansion-panel>

		<mat-expansion-panel>
			<mat-expansion-panel-header>
				Q10. What all are included in my fee ?
			</mat-expansion-panel-header>

			<ng-template matExpansionPanelContent>
				<h3 style="text-align:left;">Fee includes Following</h3>
				<p>Medical Class 1 and 2</p>
				<p>Ground classes </p>
				<p>200 hours of flying training on Single and Multi Engine </p>
				<p>All flying checks are included for issue of CPL </p>
				<p>Airline Written Exam Preparation </p>
				<p>Airline Interview Preparation</p>

				<h3 style="text-align:left;">Following are Excluded from fee </h3>
				<p>DGCA Examination Fee and license fee</p>
				<p>RT Exam fee </p>
				<p> Fooding & Lodging </p>
				<p> Traveling Expenses All other personal expenses.
				</p>
			</ng-template>
		</mat-expansion-panel>

		<mat-expansion-panel>
			<mat-expansion-panel-header>
				Q11. What is the Course intake ?
			</mat-expansion-panel-header>

			<ng-template matExpansionPanelContent>
				Online Examination is conducted at major cities all over India. Candidates are asked to give two choices for Centres. Some
				Examination Centres may be cancelled if the choice for the centre from candidates is not adequate.
			</ng-template>
		</mat-expansion-panel>


		<mat-expansion-panel>
			<mat-expansion-panel-header>
				Q12. What is the syllabus for enterance examination ?
			</mat-expansion-panel-header>

			<ng-template matExpansionPanelContent>
				Knowledge of Physics, Maths and English upto 10+2 standard required along with General Awareness of current affairs and normal
				reasoning.
			</ng-template>
		</mat-expansion-panel>

		<mat-expansion-panel>
			<mat-expansion-panel-header>
				Q13.Where we would be attending our ground classes after selection?
			</mat-expansion-panel-header>

			<ng-template matExpansionPanelContent>
				Once you are done with your medical your ground classes would start in Jaipur or Delhi as per availability of seats and instructor.
			</ng-template>
		</mat-expansion-panel>


		<mat-expansion-panel>
			<mat-expansion-panel-header>
				Q14. Where we would be flying after clearing DGCA PILOT Exams ?
			</mat-expansion-panel-header>

			<ng-template matExpansionPanelContent>
				You will fly in any DGCA approved flying club Partners in India Only.
			</ng-template>
		</mat-expansion-panel>

		<mat-expansion-panel>
			<mat-expansion-panel-header>
				Q15. Is there any Hostel accommodation available ?
			</mat-expansion-panel-header>

			<ng-template matExpansionPanelContent>
				Separate Hostels for Boys and Girls. Messing and hostel accommodation near by campus (on twin sharing basis), is provided.
				(Charges approximately Rs. 10,000/- per month).
			</ng-template>
		</mat-expansion-panel>

	</mat-accordion>

</div>